<script lang="ts">
  import { createMutation, useQueryClient } from '@tanstack/svelte-query';
  import { quotationsApi } from '$lib/api/quotations';
  import { getErrorMessage } from '$lib/api/client';
  import { route } from '$lib/state/route.svelte';
  import type { QuotationDetail } from '$lib/types';
  import ProjectPicker from './ProjectPicker.svelte';

  const { quote, canManage }: { quote: QuotationDetail; canManage: boolean } = $props();
  const client = useQueryClient();
  const assign = createMutation(() => ({
    mutationFn: (id: number | null) => quotationsApi.assignProject(quote.id, id),
    onSuccess: () => {
      // Assignment returns a flat quote; refetch rather than lose sections/terms.
      client.invalidateQueries({ queryKey: ['quotation', quote.id] });
      client.invalidateQueries({ predicate: (query) => query.queryKey.some((key) => typeof key === 'string' && key.includes('quotations')) });
    }
  }));
</script>

<div class="tym-card p-4 flex flex-col gap-3">
  {#if canManage}
    <ProjectPicker value={quote.project_id} onChange={(id) => assign.mutate(id)} disabled={assign.isPending} />
  {:else}<p class="text-sm text-dark-gray">Project group: {quote.project_id ? `#${quote.project_id}` : 'None'}</p>{/if}
  {#if assign.isError}<p class="tym-error-state">{getErrorMessage(assign.error)}</p>{/if}
  {#if quote.project_id}<button class="btn-secondary self-start" onclick={() => route.push({ tab: 'projects', id: quote.project_id! })}>Browse project quotations</button>{/if}
</div>
